module.exports = __webpack_public_path__ + "static/media/joule.18ac378a.png";